var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card-text',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})]),(_vm.url)?_c('Dropzone',{attrs:{"url":_vm.url,"maxFiles":50,"acceptedFiles":'image/jpeg,image/png,image/gif,image/bmp,image/tiff,application/pdf'},on:{"success":_vm.vdropzone_success_handler}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }